import { ITelemetryItem } from '@microsoft/applicationinsights-web';

import { UNATTRIBUTABLE_ERROR_ORIGIN } from '../constants/error-origin.constants';
import { findOriginFrame, tagExceptionOrigin } from './exception-origin.utils';

export function isNonErrorWithoutStack(value: unknown): boolean {
  if (value instanceof Error || value === null || typeof value !== 'object') {
    return false;
  }
  const stack = (value as { stack?: unknown }).stack;
  return typeof stack !== 'string' || stack.trim() === '';
}

export function tagUnattributableException(item: ITelemetryItem): void {
  tagExceptionOrigin(item, UNATTRIBUTABLE_ERROR_ORIGIN, () => false, hasNoCodeLocation);
}

function hasNoCodeLocation(stack: string | null | undefined): boolean {
  return typeof stack !== 'string' || findOriginFrame(stack) === '';
}
